import { createForm } from "svelte-forms-lib";
import * as yup from "yup";
export function aboutYouAndYourCarForm(initialValues, onSubmit) {
    return createForm({
        initialValues,
        validationSchema: yup.object().shape({
            firstName: yup.string().label("First name").required(),
            lastName: yup.string().label("Last name").required(),
            phone: yup.string().label("Phone").required(),
            email: yup.string().label("Email").email().required(),
            firstLineOfAddress: yup.string().label("First line of address").required(),
            postcode: yup.string().label("Postcode").required(),
            makeOfCar: yup.string().label("Make of car").required(),
            modelOfCar: yup.string().label("Model of car").required(),
            yearAndColourOfCar: yup.string().label("Year and colour").required(),
            howDidYouHearAboutUs: yup.string().label("How did you hear about us"),
            notes: yup.string().label("Notes"),
        }),
        onSubmit
    });
}
